import {CreditOrderData} from "./credit-order.data";
import {EntityModel} from "@fedeltapointofsale/data-client";
import {Injectable, Injector} from "@angular/core";

@Injectable()
export class CreditOrderEntityModel extends EntityModel<CreditOrderData> {
    constructor(injector: Injector) {
        super(injector, CreditOrderData);
    }

    override canCreateEntity(): Promise<boolean> {
        return Promise.resolve(false);
    }
}
